// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.search-button').on('click', function() {
    setTimeout(function() {
      jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

var productTemplate = InstantSearchResultItemProduct.prototype.getTemplate;
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
    if (tempType) return productTemplate.call(this, tempType);
 
  	return '<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">' +
  	              '<a href="{{url}}" {{newTabAttribute}}>' + 
  	                  '{{itemProductImage}}' + 
                      '{{itemLabel}}' +
  	                  '<div class="{{class.searchSuggestion}}-right">' + 
  	                      '<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>' + 
  	                      '{{itemProductSku}}' + 
  	                      '{{itemProductVendor}}' +        
  	                      '{{itemProductPrice}}' + 
  	                  '</div>' + 
  	              '</a>' + 
  	          '</li>';
    
  }
  
  var productCompile = InstantSearchResultItemProduct.prototype.compileTemplate;
  
  InstantSearchResultItemProduct.prototype.compileTemplate = function() {  
    if (!this.isShow) return '';      
   
    var itemHtml = productCompile.call(this);
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, buildLabel(this.data)); 
    
    return itemHtml;
  }
 
  function buildLabel (data) {
 
    var html = '';
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale

    html = '<div class="boost-pfs-filter-product-item-label isw-label">'
    if (soldOut) {
      html += '<div class="soldout boost-pfs-filter-label boost-pfs-filter-label-display-text">' + 'Sold Out' + '</div>';
    } else if (onSale) {
      
      var salePercent = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_max);
      html += '<div class="sale boost-pfs-filter-label boost-pfs-filter-label-display-sale_percent">' + salePercent + '%' + '</div>';
    }

    html += '</div>'

    return html;
  }
  
})();